import { render, staticRenderFns } from "./AITrainingTermsPanel.vue?vue&type=template&id=0b886437&scoped=true"
import script from "./AITrainingTermsPanel.vue?vue&type=script&lang=js"
export * from "./AITrainingTermsPanel.vue?vue&type=script&lang=js"
import style0 from "./AITrainingTermsPanel.vue?vue&type=style&index=0&id=0b886437&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b886437",
  null
  
)

export default component.exports